module.exports = __webpack_public_path__ + "icon-cart-white.png?ebbc03f98c9065a059b69487942b2168";